import {CurrentUser} from "@/pitprojekt/models/CurrentUser";
import moment from 'moment';

export class State {

    allSettingsComplete: boolean = false
    gettingSettings: boolean = false
    currentUser: CurrentUser = new CurrentUser();
    dateFrom: string = moment().subtract(1, 'months').toISOString().substr(0, 10);
    dateTo: string = moment().toISOString().substr(0, 10);
    lastYear: boolean = false;
    selectedProducts: Array<number> = [];
    selectedProduct: number = 0;
    filterProductsToPitOnly: boolean = false;
    onlyOneProductAvailable: boolean = false;
}


